import { render, staticRenderFns } from "./screenEvaluacionesCursosAdmin.vue?vue&type=template&id=1a8d1bb4"
import script from "./screenEvaluacionesCursosAdmin.vue?vue&type=script&lang=js"
export * from "./screenEvaluacionesCursosAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports